import React from 'react';
import SectionContainer from '../../../../F22/common/SectionContainer';
import FieldRow from '../../../../F22/common/FieldRow';
import { formatCurrency } from '../../../../F22/common/formatUtils';

const AntecedentesSection = ({ data, computed, updateField, updateNestedField }) => {
  const ant = data.antecedentes;
  const comp = computed.antecedentes || {};

  const updateAnt = (field, value) => updateField('antecedentes', field, value);

  return (
    <SectionContainer title="Antecedentes" subtitle="Datos base de la empresa y el ejercicio">
      <div className="f22-antecedentes">

      {/* I. Capital social (datos desde módulo Socios) */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">I. Capital social</h4>
        <div className="f22-subtable">
          <div className="f22-subtable-header">
            <div className="f22-subtable-cell" style={{ flex: 3 }}>Socio</div>
            <div className="f22-subtable-cell">RUT</div>
            <div className="f22-subtable-cell">Participación %</div>
            <div className="f22-subtable-cell">Histórico ($)</div>
            <div className="f22-subtable-cell">Reajustado ($)</div>
          </div>
          {ant.socios.map((socio, i) => (
            <div key={i} className="f22-subtable-row">
              <div className="f22-subtable-cell" style={{ flex: 3 }}>
                <span className="f22-computed-value">{socio.nombre}</span>
              </div>
              <div className="f22-subtable-cell">
                <span className="f22-computed-value">{socio.rut}</span>
              </div>
              <div className="f22-subtable-cell">
                <span className="f22-computed-value">{socio.participacion}%</span>
              </div>
              <div className="f22-subtable-cell">
                <span className="f22-computed-value">{formatCurrency(socio.capitalHistorico)}</span>
              </div>
              <div className="f22-subtable-cell">
                <span className="f22-computed-value">{formatCurrency(socio.capitalReajustado)}</span>
              </div>
            </div>
          ))}
          <div className="f22-subtable-row f22-subtable-totals">
            <div className="f22-subtable-cell" style={{ flex: 3 }}>Total capital social</div>
            <div className="f22-subtable-cell"></div>
            <div className="f22-subtable-cell">
              <span className="f22-computed-value">{ant.socios.reduce((s, so) => s + (so.participacion || 0), 0)}%</span>
            </div>
            <div className="f22-subtable-cell">
              <span className="f22-computed-value">{formatCurrency(ant.socios.reduce((s, so) => s + (so.capitalHistorico || 0), 0))}</span>
            </div>
            <div className="f22-subtable-cell">
              <span className="f22-computed-value">{formatCurrency(ant.socios.reduce((s, so) => s + (so.capitalReajustado || 0), 0))}</span>
            </div>
          </div>
        </div>
      </div>

      {/* II. Movimientos del ejercicio - Ingresos */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">II. Movimientos del ejercicio - Ingresos del giro</h4>
        <div className="f22-subtable">
          <div className="f22-subtable-header">
            <div className="f22-subtable-cell" style={{ flex: 4 }}>Concepto</div>
            <div className="f22-subtable-cell">Neto ($)</div>
            <div className="f22-subtable-cell">No Percibido ($)</div>
            <div className="f22-subtable-cell">Percibido ($)</div>
          </div>
          {[
            { label: 'Ventas netas a entidades NO relacionadas', neto: 'ventasNoRelacionadasNeto', noPerc: 'ventasNoRelacionadasNoPercibido', perc: 'ventasNoRelacionadasPercibido', editable: false },
            { label: 'Ventas netas a entidades relacionadas Pro PYME (14D3)', neto: 'ventasRelacionadasProPymeNeto', noPerc: 'ventasRelacionadasProPymeNoPercibido', perc: 'ventasRelacionadasProPymePercibido', editable: false },
            { label: 'Ventas netas a entidades relacionadas (14A)', neto: 'ventasRelacionadas14ANeto', noPerc: 'ventasRelacionadas14ANoPercibido', perc: 'ventasRelacionadas14APercibido', editable: false },
            { label: 'Cobro factura diciembre 2024 entidad no relacionada', neto: 'cobroFactura2024Neto', noPerc: 'cobroFactura2024NoPercibido', perc: 'cobroFactura2024Percibido', editable: true },
          ].map((row) => (
            <div key={row.neto} className="f22-subtable-row">
              <div className="f22-subtable-cell" style={{ flex: 4 }}>{row.label}</div>
              <div className="f22-subtable-cell">
                {row.editable ? (
                  <input className="f22-input f22-input-sm" type="text" value={formatCurrency(ant[row.neto])}
                    onChange={(e) => {
                      const val = parseInt(e.target.value.replace(/\./g, '').replace(/[^0-9-]/g, ''), 10) || 0;
                      updateAnt(row.neto, val);
                    }} />
                ) : (
                  <span className="f22-system-value">{formatCurrency(ant[row.neto])}</span>
                )}
              </div>
              <div className="f22-subtable-cell">
                {row.editable ? (
                  <input className="f22-input f22-input-sm" type="text" value={formatCurrency(ant[row.noPerc])}
                    onChange={(e) => {
                      const val = parseInt(e.target.value.replace(/\./g, '').replace(/[^0-9-]/g, ''), 10) || 0;
                      updateAnt(row.noPerc, val);
                    }} />
                ) : (
                  <span className="f22-system-value">{formatCurrency(ant[row.noPerc])}</span>
                )}
              </div>
              <div className="f22-subtable-cell">
                <span className="f22-computed-value">{formatCurrency((ant[row.neto] || 0) - (ant[row.noPerc] || 0))}</span>
              </div>
            </div>
          ))}
          <div className="f22-subtable-row f22-subtable-totals">
            <div className="f22-subtable-cell" style={{ flex: 4 }}>Total ingresos del giro</div>
            <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(comp.totalIngresosGiroNeto)}</span></div>
            <div className="f22-subtable-cell"></div>
            <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(comp.totalIngresosGiroPercibido)}</span></div>
          </div>
        </div>
      </div>

      {/* Otros Ingresos */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Otros Ingresos</h4>
        <FieldRow label="Ingresos netos por venta computador" sign="(+)" value={ant.ingresosVentaComputador}
          onChange={(v) => updateAnt('ingresosVentaComputador', v)} />
        <FieldRow label="Crédito otorgado por Banco" sign="(+)" value={ant.creditoBanco} disabled />
        <FieldRow label="Total otros ingresos" sign="(=)" value={comp.totalOtrosIngresos} computed className="f22-field-subtotal" />
      </div>

      {/* Dividendos Percibidos */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Dividendos Percibidos</h4>
        {[
          { label: 'Dividendo 1 - con crédito IDPC sujeto a restitución c/ D° dev.', perc: 'dividendo1Percibido' },
          { label: 'Dividendo 2 - con crédito IDPC NO sujeto a restitución c/ D° dev.', perc: 'dividendo2Percibido' },
          { label: 'Dividendo 3 - con crédito IDPC acumulado al 31.12.2016 c/ D° dev.', perc: 'dividendo3Percibido' },
          { label: 'Dividendo 4 - sin crédito', perc: 'dividendo4Percibido' },
          { label: 'Dividendo 5 - Ingreso No Constitutivo de Renta', perc: 'dividendoINR' },
        ].map((row) => (
          <FieldRow key={row.perc} label={row.label} sign="(+)" value={ant[row.perc]} disabled />
        ))}
        <FieldRow label="Total dividendos percibidos" sign="(=)" value={comp.totalDividendosPercibido} computed className="f22-field-subtotal" />
      </div>

      {/* Egresos */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Egresos</h4>
        <FieldRow label="Compras netas existencias 2025" sign="(-)" value={ant.comprasPagado} disabled />
        <FieldRow label="Compra neta camioneta de reparto, usada" sign="(-)" value={ant.compraCamionetaPagado}
          onChange={(v) => updateAnt('compraCamionetaPagado', v)} />
        <FieldRow label="Remuneraciones del ejercicio, monto bruto" sign="(-)" value={ant.remuneracionesBruto} disabled />
        <FieldRow label="Remuneraciones adeudadas (pendiente pago)" sign="(-)" value={ant.remuneracionesAdeudado} disabled />
        <FieldRow label="Remuneraciones pagadas (neto)" sign="(-)" value={comp.remuneracionesPagado} computed />
        <FieldRow label="Honorarios del ejercicio, monto bruto" sign="(-)" value={ant.honorariosBruto} disabled />
        <FieldRow label="Honorarios adeudados (pendiente pago)" sign="(-)" value={ant.honorariosAdeudado} disabled />
        <FieldRow label="Honorarios pagados (neto)" sign="(-)" value={comp.honorariosPagado} computed />
        <FieldRow label="Gastos generales" sign="(-)" value={ant.gastosGenerales} disabled />
        <FieldRow label="Arriendos" sign="(-)" value={ant.arriendos} disabled />
        <FieldRow label="Cotizaciones previsionales diciembre 2024" sign="(-)" value={ant.cotizacionesDic2024}
          onChange={(v) => updateAnt('cotizacionesDic2024', v)} />
        <FieldRow label="Retenciones IUSC diciembre 2024" sign="(-)" value={ant.retencionesIUSCDic2024}
          onChange={(v) => updateAnt('retencionesIUSCDic2024', v)} />
        <FieldRow label="Pago proveedores 2024" sign="(-)" value={ant.pagoProveedores2024}
          onChange={(v) => updateAnt('pagoProveedores2024', v)} />
        <FieldRow label="Amortización capital préstamo" sign="(-)" value={ant.amortizacionCapital} disabled />
        <FieldRow label="Interés por préstamo" sign="(-)" value={ant.amortizacionInteres} disabled />
        <FieldRow label="Pago intereses, reajustes y multas fiscales" sign="(-)" value={ant.pagoInteresesMultas}
          onChange={(v) => updateAnt('pagoInteresesMultas', v)} />
        <FieldRow label="Pago IDPC AT 2025" sign="(-)" value={ant.pagoIDPCAT2025} disabled />
        <FieldRow label="PPM pagados" sign="(-)" value={ant.ppmHistorico} disabled />
        <FieldRow label="Total egresos del ejercicio" sign="(=)" value={comp.totalEgresosPagado} computed className="f22-field-subtotal" />
      </div>

      {/* IV. CPTS al 31.12.2024 */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">III. CPTS determinado al 31.12.2024</h4>
        <FieldRow label="CPTS informado en código 1545 del recuadro N° 19 del F-22 AT 2025"
          value={ant.cptsAl31Dic2024} disabled />
        <FieldRow label="Capital aportado empresas que inician actividades en el año comercial que corresponda a esta declaración"
          code="1374" value={comp.capitalAportado1374} disabled />
      </div>

      {/* V. Otros antecedentes */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">IV. Otros antecedentes</h4>
        <FieldRow label="Valor UF al 31.12.2025" value={ant.valorUF} type="number" decimals={2} disabled />
        <FieldRow label="Tasa IDPC" value={ant.tasaIDPC * 100} type="number" suffix="%" computed />
        <FieldRow label="Factor IDPC" value={comp.factorIDPC} type="number" decimals={6} computed />
      </div>

      {/* Retiros del ejercicio */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">Retiros actualizados al 31.12.2025</h4>
        <p className="f22-hint">Datos cargados desde Socios y Dividendos (C5 × factor corrección monetaria).</p>
        <div className="f22-subtable">
          <div className="f22-subtable-header">
            <div className="f22-subtable-cell" style={{ flex: 3 }}>Socio / Receptor</div>
            <div className="f22-subtable-cell">Fecha Retiro</div>
            <div className="f22-subtable-cell">C5 Histórico ($)</div>
            <div className="f22-subtable-cell">Factor</div>
            <div className="f22-subtable-cell">Actualizado ($)</div>
          </div>
          {(ant.retiros || []).length === 0 ? (
            <div className="f22-subtable-row">
              <div className="f22-subtable-cell" style={{ flex: 5, color: '#999', fontStyle: 'italic' }}>
                Sin retiros registrados. Ingresa los datos en Socios y Dividendos → Retiros / Remesas / Dividendos.
              </div>
            </div>
          ) : (ant.retiros || []).map((retiro, i) => {
            const factor = retiro.retiroHistorico > 0
              ? (retiro.retiroActualizado / retiro.retiroHistorico).toFixed(6)
              : '—';
            return (
              <div key={i} className="f22-subtable-row">
                <div className="f22-subtable-cell" style={{ flex: 3 }}>
                  <span className="f22-computed-value">{retiro.nombre}</span>
                </div>
                <div className="f22-subtable-cell">
                  <span className="f22-computed-value">{retiro.fechaRetiro || '—'}</span>
                </div>
                <div className="f22-subtable-cell">
                  <span className="f22-computed-value">{formatCurrency(retiro.retiroHistorico)}</span>
                </div>
                <div className="f22-subtable-cell">
                  <span className="f22-computed-value">{factor}</span>
                </div>
                <div className="f22-subtable-cell">
                  <span className="f22-computed-value">{formatCurrency(retiro.retiroActualizado)}</span>
                </div>
              </div>
            );
          })}
          <div className="f22-subtable-row f22-subtable-totals">
            <div className="f22-subtable-cell" style={{ flex: 3 }}>Total retiros del ejercicio</div>
            <div className="f22-subtable-cell"></div>
            <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(comp.totalRetirosHistorico)}</span></div>
            <div className="f22-subtable-cell"></div>
            <div className="f22-subtable-cell"><span className="f22-computed-value">{formatCurrency(comp.totalRetirosActualizado)}</span></div>
          </div>
        </div>
      </div>

      {/* VI. Remanentes del ejercicio anterior */}
      <div className="f22-subsection">
        <h4 className="f22-subsection-title">V. Saldos registros de renta al 31.12.2024</h4>
        <p className="f22-hint">Informados en recuadros N° 20 y 21 del F-22 AT 2025</p>
        <FieldRow label="RAI" value={ant.remanentesAnteriores?.RAI} disabled />
        <FieldRow label="REX - RAP" value={ant.remanentesAnteriores?.REX_RAP} disabled />
        <FieldRow label="REX - Ingresos No Renta" value={ant.remanentesAnteriores?.REX_INR} disabled />
        <FieldRow label="SAC - No sujeto a restitución, sin devolución" value={ant.remanentesAnteriores?.SAC_noSujetoSinDev} disabled />
        <FieldRow label="SAC - No sujeto a restitución, con devolución" value={ant.remanentesAnteriores?.SAC_noSujetoConDev} disabled />
        <FieldRow label="SAC - Sujeto a restitución, con devolución" value={ant.remanentesAnteriores?.SAC_sujetoConDev} disabled />
        <FieldRow label="SAC - IPE, sin devolución" value={ant.remanentesAnteriores?.SAC_IPE_sinDev} disabled />
        <FieldRow label="SAC - Crédito IDPC acumulado al 31.12.2016, con devolución" value={ant.remanentesAnteriores?.SAC_2016_conDev} disabled />
        <FieldRow label="STUT" value={ant.remanentesAnteriores?.STUT} disabled />
      </div>
      </div>
    </SectionContainer>
  );
};

export default AntecedentesSection;
